export default __webpack_public_path__ + "static/SuisseIntlMedium-a2ec212cacba9af579b6e30d4ac85e96.woff";